import GiftCardPreview from '../../components/pages/gift_card_sessions/GiftCardPreview.vue'

export default {
  components: {
    GiftCardPreview
  }
}
